import { Stack, Container, Grid } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { FixNavbarSpace } from '../Utilities/Navbar';

const EmployeeIntakeForm: React.FC = () => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        // Cargar el script de JotForm para manejar el iframe
        const script = document.createElement('script');
        script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
        script.async = true;
        script.onload = () => {
            if ((window as any).jotformEmbedHandler) {
                (window as any).jotformEmbedHandler(
                    "iframe[id='JotFormIFrame-251344392435052']",
                    'https://form.jotform.com/'
                );
            }
        };
        document.body.appendChild(script);

        return () => {
            // Limpieza: eliminar el script cuando el componente se desmonte
            document.body.removeChild(script);
        };
    }, []);

    return (
        <Stack minHeight="60vh" alignItems="center" spacing={5}>
        <FixNavbarSpace />
        <Container>
          <Grid  justifyContent="center">
        <div>
            <iframe
                ref={iframeRef}
                id="JotFormIFrame-251344392435052"
                title="Employee Intake Form"
                onLoad={() => window.parent.scrollTo(0, 0)}
                allow="geolocation; microphone; camera; fullscreen"
                src="https://form.jotform.com/251344392435052"
                frameBorder="0"
                style={{
                    minWidth: '100%',
                    maxWidth: '100%',
                    height: '539px',
                    border: 'none'
                }}
                scrolling="no"
            ></iframe>
        </div>
        </Grid>
      </Container>
    </Stack>
    );
};

export default EmployeeIntakeForm;
